import { Accordion, AccordionDetails, AccordionSummary, makeStyles, withStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
export const useStyles = makeStyles({
    summary: {
        border: `1px solid ${colorPalette.gray200}`,
    },
    title: {
        color: colorPalette.gray900,
        fontSize: '16px',
        fontWeight: 600,
        fontFamily: 'RakutenSansUiSemiBold, serif',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        width: '60vw',
    },
    subTitle: {
        color: colorPalette.gray500,
        fontSize: '14px',
        fontWeight: 400,
    },
    detailsLite: {
        padding: '0 16px 16px 16px !important',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderTop: 'none',
    },
    details: {
        padding: '16px !important',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        borderTop: `1px solid ${colorPalette.gray200}`
    },
    detailsContent: {
        color: colorPalette.gray700,
        fontSize: '14px',
        fontWeight: 400,
        width: '100%',
    },
    customAccordionwithoutBorder: {
        borderRadius: '0px !important',
        borderLeft: '0px !important',
        borderRight: '0px !important',
    },
    customAccordionLite: {
        borderRadius: '4px',
        border: `1px solid ${colorPalette.gray200}`,
        "&:hover": {
            boxShadow: `0 0 0 4px ${colorPalette.gray100}`,
        },
        "&:active": {
            border: `1px solid ${colorPalette.gray300}`,
        },
        '&:expanded': {
            color: 'red',
        },
    },
    'detailsContent > * > Button': {
        width: '100%',
        marginTop: '12px',
    },
    content: {
        marginLeft: '12px',
    },
    icon: {
        width: '32px',
        height: '32px',
        borderRadius: '4px',
        backgroundColor: (props) => props.iconBackgroundColor ? colorPalette[props.iconBackgroundColor] : colorPalette.gray700,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: '12px',
    },
});
export const CustomAccordion = withStyles({
    root: {
        borderTop: `1px solid ${colorPalette.gray200}`,
        borderBottom: `1px solid ${colorPalette.gray200}`,
        '&:before': {
            display: 'none',
        },
        boxShadow: 'none',
    },
    expanded: {
        border: `1px solid ${colorPalette.gray800}`,
        '&$expanded': {
            margin: 0,
        },
        '&:active': {
            border: `1px solid ${colorPalette.gray600}`,
        },
    },
})(Accordion);
export const CustomSummary = withStyles({
    root: {
        backgroundColor: ({ summaryColor }) => summaryColor ? colorPalette[summaryColor] : '',
    },
    expanded: {
        '&$expanded': {
            minHeight: 'initial',
        },
    },
    expandIcon: {
        '&$expand': {
            transform: 'rotate(180deg)',
        },
    },
    content: {
        margin: '16px 0',
        '&$expanded': {
            margin: '16px 0',
        },
    },
})(AccordionSummary);
export const CustomAccordionDetails = withStyles({
    root: {
        backgroundColor: ({ detailsColor }) => detailsColor ? colorPalette[detailsColor] : '',
    },
})(AccordionDetails);
